export class Rect
{
  private x: number;
  private y: number;
  private w: number;
  private h: number;

  private w2: number;
  private h2: number;
  //private center_x: number;
  //private center_y: number;

  constructor( x: number, y: number, w: number, h: number )
  {
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;

    this.w2 = Math.floor( w / 2 );
    this.h2 = Math.floor( h / 2 );

    //this.center_x = Math.floor( (x + w) / 2 );
    //this.center_y = Math.floor( (y + h) / 2 );
  }

  clone(): Rect
  {
    return new Rect( this.x, this.y, this.w, this.h );
  }

  toStr(): string
  {
    return `{${this.x}, ${this.y}, ${this.w}, ${this.h}}`;
  }

  getX(): number { return this.x; }
  getY(): number { return this.y; }
  getW(): number { return this.w; }
  getH(): number { return this.h; }

  getW2(): number { return this.w2; }
  getH2(): number { return this.h2; }

  centerX(): number { return this.x + this.w2; }
  centerY(): number { return this.y + this.h2; }

  //centerX_withParentScale( parent_scale: number ): number { return this.x + this.w2 * parent_scale; }
  //centerY_withParentScale( parent_scale: number ): number { return this.y + this.h2 * parent_scale; }

  setX( x:number ): void { this.x = x; }
  setY( y:number ): void { this.y = y; }

  resize(w: number, h: number): void {
    this.w = w;
    this.h = h;
    this.w2 = Math.floor( w / 2 );
    this.h2 = Math.floor( h / 2 );
  }

  // Вычисляет площадь прямоугольника
  area(): number
  {
    return this.w * this.h;
  }

  // Вычисляет периметр прямоугольника
  perimeter(): number
  {
    return 2 * ( this.w + this.h );
  }

  // Проверяет, содержит ли прямоугольник точку (x, y)
  contains( x: number, y: number ): boolean
  {
    return x >= this.x && x <= this.x + this.w &&
      y >= this.y && y <= this.y + this.h;
  }

  // Проверяет, пересекается ли этот прямоугольник с другим
  intersects( other: Rect ): boolean
  {
    return this.x < other.x + other.w &&
      this.x + this.w > other.x &&
      this.y < other.y + other.h &&
      this.y + this.h > other.y;
  }

  // Смещает прямоугольник на (dx, dy)
  translate( dx: number, dy: number ): void
  {
    this.x += dx;
    this.y += dy;
  }

  // Возвращает минимальный прямоугольник, охватывающий этот и другой прямоугольники
  union( other: Rect ): Rect
  {
    const x1 = Math.min( this.x, other.x );
    const y1 = Math.min( this.y, other.y );
    const x2 = Math.max( this.x + this.w, other.x + other.w );
    const y2 = Math.max( this.y + this.h, other.y + other.h );
    return new Rect( x1, y1, x2 - x1, y2 - y1 );
  }

  // Возвращает пересечение этого прямоугольника с другим, или null, если пересечения нет
  intersection( other: Rect ): Rect | null
  {
    const x1 = Math.max( this.x, other.x );
    const y1 = Math.max( this.y, other.y );
    const x2 = Math.min( this.x + this.w, other.x + other.w );
    const y2 = Math.min( this.y + this.h, other.y + other.h );
    if ( x2 >= x1 && y2 >= y1 )
    {
      return new Rect( x1, y1, x2 - x1, y2 - y1 );
    }
    return null;
  }

}
